import { ALLOWED_ROLES } from '@src/packages/utils';

/**
 * Charts inherit the scope of the board that holds them: a division board is
 * writable only by that division, an org board only by org-level roles.
 *
 * Without `divId`, `ComponentBlocker` matches the role in ANY assigned
 * division, so a div admin/editor of one division would see write actions on
 * every board.
 *
 * @param {{ divId?: string | null } | null | undefined} boardSelected
 * @returns {{ divId: string | undefined, allowedRoles: { UPDATE: string[], DELETE: string[] } }}
 */
export const getChartAccess = boardSelected => {
  const divId = boardSelected?.divId ?? undefined;
  const charts = divId
    ? ALLOWED_ROLES.ORGANIZATIONS.DIVISIONS.DASHBOARDS.CHARTS
    : ALLOWED_ROLES.ORGANIZATIONS.DASHBOARDS.CHARTS;

  return {
    divId,
    allowedRoles: { UPDATE: charts.UPDATE, DELETE: charts.DELETE },
  };
};
